
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.517.3C1.613.48.783 1.18.464 2.03.27 2.549.283 2.079.283 8.5c0 5.391.005 5.9.056 6.083.287 1.032.961 1.749 1.934 2.057l.244.077h14.966l.244-.077c.967-.306 1.616-.991 1.934-2.04.05-.167.056-.61.065-4.917.01-5.213.019-4.962-.195-5.516-.266-.692-.917-1.336-1.609-1.596-.456-.17-.472-.171-3.646-.172l-2.959-.001-.934-1.004C9.712.672 9.413.373 9.317.329 9.19.271 9.011.268 5.917.271 4.12.273 2.59.286 2.517.3m7.089 2.439c.599.638.993 1.031 1.077 1.075.132.069.171.07 3.384.086l3.25.017.192.097c.377.191.668.623.727 1.078.041.323.038 8.7-.004 8.99-.046.314-.16.549-.38.779-.212.223-.404.329-.675.374-.261.042-14.093.042-14.354 0-.271-.045-.463-.151-.675-.374a1.332 1.332 0 01-.38-.779c-.046-.317-.046-10.847 0-11.164.046-.314.16-.549.38-.779.203-.214.408-.331.645-.371.086-.015 1.442-.029 3.013-.031l2.856-.004.944 1.006","fill-rule":"evenodd","fill":"currentColor"}})])
          )
        }
      }
    